import React, { useEffect, useRef, useState } from 'react'
import InputForm from 'src/components/ComponentesFormularios/InputForm';
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidthHeader,
    classResponsiveFormDoubleWidthHeaderWithoutPaddingX,
    classResponsiveFormWithoutPaddingX,
    classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED,
    optionsEstados,
    optionsYesNo,
    ERROREMAILFIELDREQUIRED
} from "../../../data/ConstantForm";
import AgGridTable from 'src/components/AgGridTable';
import TabsClassic from 'src/components/TabsClassic';
import { evaluacionSolicitudServices } from 'src/services/apiEvaluacionSolicitudes';

import { isEmpty, isObject, isArray } from 'src/util/is';
import Zoom from 'react-medium-image-zoom';
import Button from '@mui/material/Button';

import TextareaAutosize from '@mui/material/TextareaAutosize';
import SelectFormVirtualize from 'src/components/ComponentesFormularios/SelectFormVirtualize';
import Tooltip from "@mui/material/Tooltip";
import { Colors } from 'src/assets/colors/Colors';
import { Modal } from "react-bootstrap";
import ExternalActionsTable from 'src/components/ExternalActionsTable';
import NestedSelectVirtualizeForm from 'src/components/ComponentesFormularios/NestedSelectVirtualizeForm';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalConstants } from 'src/data/GlobalConstants';

import { modalCRUDService } from 'src/services/modalCRUDService';
import { dateToStringFormat } from 'src/util/functions';

const columnDef = [
    { headerName: 'Detalle', field: "detalle", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: '', field: "check", checkboxSelection: true,/* headerCheckboxSelection: true, */ resizable: true, sortable: false, filter: false, width: 20 },
    { headerName: 'Referencia', field: "referencia", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Solicitudes Mantenimiento', field: "solicitudMantenimiento", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Solicitudes Retiro', field: "solicitudRetiro", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Solicitudes Instalación', field: "solicitudInstalacion", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Disponibles en Bodega', field: "disponibleBodega", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Aprobadas sin VoBo', field: "aprobadasVOBO", resizable: true, sortable: false, filter: false, width: 100 }
]

const columnDefDisponibles = [
    { headerName: '', field: "check", checkboxSelection: true,/* headerCheckboxSelection: true, */ resizable: true, sortable: false, filter: false, width: 40 },
    { headerName: 'Id Propietario', field: "idPropietario", resizable: true, sortable: false, filter: false, hide: true, width: 100 },
    { headerName: 'Propietario', field: "nmPropietario", resizable: true, sortable: false, filter: false, hide: true, width: 100 },
    { headerName: 'Id A.C', field: "nbAgenteComercial", resizable: true, sortable: false, filter: false, hide: true, width: 100 },
    { headerName: 'A.C', field: "nmAgenteComercial", resizable: true, sortable: false, filter: false, hide: true, width: 100 },
    { headerName: 'Id Ubicación', field: "idUbicacion", resizable: true, sortable: false, filter: false, hide: true, width: 100 },
    { headerName: 'Ubicacion', field: "nmUbicacion", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Tp Referencia', field: "tpReferencia", resizable: true, sortable: false, filter: true, width: 100 },
    { headerName: 'Id Referencia', field: "nbReferencia", resizable: true, sortable: false, filter: true, width: 100 },
    { headerName: 'Referencia', field: "nmReferencia", resizable: true, sortable: false, filter: true, width: 100 },
    { headerName: 'Marca', field: "nmMarca", resizable: true, sortable: false, filter: true, width: 100 },
    { headerName: 'Id Activo', field: "nbActivo", resizable: true, sortable: false, filter: true, width: 100 },
    { headerName: 'Serial', field: "nbSerial", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Id Est. Disp.', field: "idEstadoDisponibilidad", resizable: true, sortable: false, filter: false, hide: true, width: 100 },
    { headerName: 'Est. Disp.', field: "nmEstadoDisponibilidad", resizable: true, sortable: false, filter: true, width: 100 },
    { headerName: 'Id Estado', field: "idEstadoActivo", resizable: true, sortable: false, filter: false, hide: true, width: 100 },
    { headerName: 'Estado', field: "nmEstadoActivo", resizable: true, sortable: false, filter: false, width: 100 },
    { headerName: 'Fecha Activo', field: "dtActivo", resizable: true, sortable: false, filter: false, width: 100 },
]

const columnDefVehiculos = [
    { headerName: '', field: "check", checkboxSelection: true,/* headerCheckboxSelection: true, */ resizable: true, sortable: false, filter: false, width: 40 },
    { headerName: 'Agente C.', field: "nbAgenteComercial", resizable: true, sortable: false, filter: false, width: 110 },
    { headerName: 'Placa', field: "nbPlaca", resizable: true, sortable: false, filter: false, width: 110 },
    { headerName: 'Clase Vehiculo', field: "nmClaseVehiculo", resizable: true, sortable: false, filter: false, width: 110 },
    { headerName: 'Id Responsable', field: "nbResponsable", resizable: true, sortable: false, filter: false, width: 110 },
    { headerName: 'Responsable', field: "nmResponsable", resizable: true, sortable: false, filter: false, width: 110 },
    { headerName: 'Celular', field: "txCelular", resizable: true, sortable: false, filter: false, width: 110 },
]

const columnDefTransportadores = [
    { headerName: '', field: "check", checkboxSelection: true,/* headerCheckboxSelection: true, */ resizable: true, sortable: false, filter: false, width: 40 },
    { headerName: 'Documento', field: "documento", resizable: true, sortable: false, filter: false, minWidth: 110 },
    { headerName: 'Conductor', field: "nombre", resizable: true, sortable: false, filter: false, minWidth: 110 },
    { headerName: 'Celular', field: "celular", resizable: true, sortable: false, filter: false, minWidth: 110 }
]

const AsignarActivo = ({ open, toggleOverlay, data, table, activo, activoS }) => {

    const [dataTable, setDataTable] = useState([])
    const dispatch = useDispatch()
    const methods = useForm()
    const { control, getValues, setValue, handleSubmit } = methods;
    const generalServicesState = useSelector(state => state.generalServices)

    let saveData = {}

    const aceptar = async () => {

        try {

            saveData = {
                idSolicitud: data.idSolicitud,
                tpSolicitud: 'Cambio Activo',
                clase: null,
                comment: '',
                activo: null,
                estado: data.idEstado,
                jsItems: null
            }

            let activo = ''
            let reporteNoRegistra = false;

            table.current.api.forEachNodeAfterFilter(nodo => {
                if (nodo.selected) {
                    //* Cuando el tpGrupSolciitud es Reporte Activo no Registrado unicamente se puede asignar un activo con la misma placa que fue ingresada en la solicitud
                    if(data.tpGrupSolicitud === 'Reporte Activo No Registrado' && (nodo.data.nbActivo !== data.Activo)){
                      reporteNoRegistra = true;
                    }else{
                        saveData = {
                            ...saveData,
                            activo: nodo.data.nbActivo
                        }
                        activo = nodo.data.nbActivo
                    }
                }
            })


            if(reporteNoRegistra){
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Solo puedes asignar un activo con la misma placa, porfavor validar!' } });
                return;
            }

            if (activo == '') {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Por favor Seleccione un Activo' } });
                return
            }

            let res = await evaluacionSolicitudServices.setAsignacion(saveData)

            if (res.data.idmsg === 200) {
                toggleOverlay()
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: res.data?.txmsg } });
                dispatch({
                    type: 'setStateGeneralServices', generalServices: {
                        ...generalServicesState,
                        updateActivoAsignado: true
                    }
                })

                dispatch({
                    type: 'setStateGeneralServices', generalServices: {
                        ...generalServicesState,
                        updateSolicitud: true
                    }
                })
            }

        } catch (error) {
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Ha ocurrido un error' } });
        }

    }

    const onGridReady = params => {

        params.api.forEachNodeAfterFilter(nodo => {
            nodo.setSelected(nodo.data.nbActivo === activo)
        })
    }

    useEffect(async () => {

        let res = await evaluacionSolicitudServices.getDisponibles({ tpSolicitud: data.tpSolicitud, agente: data.nbAgenteComercial, tpReferencia: data.tpReferencia })

        setDataTable(res.data)

    }, [data.nbAgenteComercial])

    return (
        <div>
            <FormProvider {...methods} className="w-100">
                <Modal
                    id={`modalId`}
                    size={'lg'}
                    show={open}
                    onHide={toggleOverlay}
                    backdrop="static"
                    className="modalCRUD p-0 m-0"
                    centered
                >
                    <Modal.Header className="headerModal" closeButton>
                        <a className="icon-container">
                            <div />
                            <i className="fas fa-pen" />
                        </a>
                        <Modal.Title className="mb-0">
                            Asignar Activo
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4 py-3">

                        {/* <p className="font-weight-bold fontSize1rem">Solicitud de Activo No: {data.idSolicitud} - {data.tpGrupSolicitud}</p> */}

                        <div>
                            <div className={`d-flex align-items-center justify-content-end mb-3`}>
                                <ExternalActionsTable
                                    accionVisibilidadColumnas={table}
                                />
                                <Tooltip title="Visto Bueno" aria-label="guardar-producto">
                                    <a className="icon-container-actions d-flex "
                                        onClick={() => aceptar()}>
                                        <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                        <i style={{ color: Colors.COLOR_GREEN_DARK }} className="far fa-save fa-2x" />
                                    </a>
                                </Tooltip>

                            </div>

                            <table style={{ width: '100%', marginTop: '10px' }} className={'d-table'} >
                                <thead>
                                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040'}}>
                                        <td>Id Referencia</td>
                                        <td>Referencia</td>
                                        <td>Cantidad</td>
                                        <td>Placa Registrada</td>
                                        <td>Placa Solicitud</td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr style={{ fontWeight: 'bold' }} >
                                        <td className='pl-1'>{activoS?.nbRecurso}</td>
                                        <td className='pl-1'>{activoS?.nmRecurso}</td>
                                        <td className='pl-1'>{activoS?.nbCantidad}</td>
                                        <td className='pl-1'>{data?.tpGrupSolicitud == 'Petición de Activo' || data?.tpGrupSolicitud == 'Petición Cambio' ? '' : data?.nbActivo}</td>
                                        <td className='pl-1'>{data?.Activo}</td>
                                    </tr>
                                </tbody>
                            </table>

                        {/* <table style={{ width: '100%', marginTop: '10px' }} 
                            className={`${data?.estadoActivo == undefined || data?.estadoActivo == null ? 'd-none' : ''}`}>
                        <thead>
                            <tr style={{ fontWeight: 'bold', color: '#37A6DE' }}>
                                <td colSpan={5}>DATOS DE ACTIVO ASIGNADO</td>
                                <td colSpan={3}>ESTADOS</td>
                            </tr>
                            <tr style={{ backgroundColor: '#ebebeb', color: '#404040', }}>
                                <td>Referencia</td>
                                <td>Placa</td>
                                <td>Nombre</td>
                                <td>Propietario</td>
                                <td>De Ubicación</td>
                                <td>De Disponibilidad</td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr style={{ fontWeight: 'bold' }}>
                                <td>{data['estadoActivo'].referencia}</td>
                                <td>{data['estadoActivo'].activo}</td>
                                <td>{data['estadoActivo'].tipo}</td>
                                <td>{data['estadoActivo'].propietario}</td>
                                <td>{data['estadoActivo'].ubicacion}</td>
                                <td>{data['estadoActivo'].disponibilidad}</td>
                            </tr>
                        </tbody>
                        </table> */}

                            <AgGridTable
                                referencia={table}
                                columnDef={columnDefDisponibles}
                                dataList={dataTable || []}
                                onGridReady={onGridReady}
                                rowSelection="single"
                                height="35vh"
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </FormProvider>
        </div>
    );
}

const FormDialog = ({ open, toggleOverlay, data, causales }) => {

    const methods = useForm()
    const dispatch = useDispatch()
    const generalServicesState = useSelector(state => state.generalServices)
    const [comment, setComment] = useState('')
    const [states, setstates] = useState({  supervisor: [{ id: 52, text: 'Aprobar' }, { id: 56, text: 'Denegar' }], 
                                            gestorActivos: [{ id: 53, text: 'Aprobar' }, { id: 57, text: 'Denegar' }],
                                            documentsGenerados: [{ id: 55, text: 'Aprobar' }, { id: 58, text: 'Denegar' }] 
                                        })

    let obj_causales = {
        51: states.supervisor,
        52: states.gestorActivos,
        54: states.documentsGenerados
    }

    const { control, getValues, setValue, handleSubmit } = methods;

    const aprobacion = useWatch({
        name: "aprobacion",
        control
    })

    const causal = useWatch({
        name: "causal",
        control
    })

    const aceptar = async () => {

        if (aprobacion == '' || aprobacion == undefined || causal == '' || causal == undefined) {

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Seleccione un motivo y un causal' } });
            return
        }

        let jsItems = JSON.parse(data.jsItemSolicitudes)

        let activoAsignado = jsItems.arrItems.find(el => el.tpSolicitud == 'Ref. Activo')

        let senData = { estado: aprobacion?.id, 
                        clase: causal?.id, 
                        comment, 
                        idSolicitud: data?.idSolicitud, 
                        tpSolicitud: data?.idEstado == 51 ? 'VoBo Jefe Comercial' : 'VoBo Gestor de Activos', 
                        tpGrupSolicitud: data?.tpGrupSolicitud, 
                        activo: data?.nbActivo,
                        // activoAsignado,
                        fecha: data?.dtSolicitud 
                    }

        try {

            let res = await evaluacionSolicitudServices.setAsignacion(senData)

            if (res.status) {
                toggleOverlay()
                modalCRUDService.clear()
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: res.data?.txmsg } });
                dispatch({
                    type: 'setStateGeneralServices', generalServices: {
                        ...generalServicesState,
                        updateSolicitud: true
                    }
                })
            }
            else {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: res?.msg } });
            }

        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Ha ocurrido un error' } });
            console.log(error)
        }
    }

    return (
        <div>
            <FormProvider {...methods} className="w-100">
                <Modal
                    id={`modalId`}
                    size={'sm'}
                    show={open}
                    onHide={toggleOverlay}
                    backdrop="static"
                    className="modalCRUD p-0 m-0"
                    centered
                >
                    <Modal.Header className="headerModal" closeButton>
                        <a className="icon-container">
                            <div />
                            <i className="fas fa-pen" />
                        </a>
                        <Modal.Title className="mb-0">
                            Evaluación Solicitud
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4">

                        <p className="font-weight-bold fontSize1rem">Solicitud de Activo No: {data.idSolicitud} - {data.tpGrupSolicitud}</p>

                        <div className="d-flex align-items-center justify-content-between mt-3">

                            <SelectFormVirtualize disabled={false} inputProps={{ control }} showId={false} identificador="aprobacion" label=""
                                options={obj_causales[data.idEstado]} value={1} required={false} className={`w-250 mr-1`}
                                customError={null} multiple={true} isMulti={false} />

                            <NestedSelectVirtualizeForm keyIdentificador="causal" label="Causal" required={true}
                                className={`w-250`} options={causales?.arrCausales}
                                customError={null}
                                keyFatherValue="aprobacion" />
                        </div>

                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={3}
                            placeholder="Comentario"
                            style={{ width: '100%', marginTop: '15px', resize: 'none', borderColor: 'hsl(0, 0%, 80%)' }}
                            onChange={(e) => setComment(e.target.value)}
                        />

                        <div className="d-flex justify-content-end align-items-center">
                            <Button className="mx-1" onClick={() => aceptar()}>Aceptar</Button>
                            <Button className="mx-1" onClick={toggleOverlay}>Cancelar</Button>
                        </div>

                    </Modal.Body>
                </Modal>
            </FormProvider>
        </div>
    );
}

const FormDialogAsignarTransporte = ({ open, toggleOverlay, data, dataVehiculos, tableVehiculo, dataConductores, tableTransportador, transporteSelected }) => {

    const [dataTable, setDataTable] = useState([])
    // const [saveData, setSaveData] = useState({})
    const methods = useForm()
    const dispatch = useDispatch()
    const generalServicesState = useSelector(state => state.generalServices)

    const { control, getValues, setValue, handleSubmit } = methods;

    let saveData = {}

    const aceptar = async () => {

        let jsVehiculo = {},
            jsTransportador = {}

        tableVehiculo.current.api.forEachNodeAfterFilter(nodo => {
            if (nodo.selected) {
                jsVehiculo = {
                    nbPlaca: nodo.data.nbPlaca,
                    nmClase: nodo.data.nmClaseVehiculo,
                    nmResponsable: nodo.data.nmResponsable
                }
            }
        })

        tableTransportador.current.api.forEachNodeAfterFilter(nodo => {
            if (nodo.selected) {
                jsTransportador = {
                    nbDocumento: nodo.data.documento,
                    nmConductor: nodo.data.nombre,
                    nbTelefono: nodo.data.celular
                }
            }
        })

        if (Object.keys(jsVehiculo).length <= 0 || Object.keys(jsTransportador).length <= 0) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Por favor Seleccione un vahiculo y un transportador' } });
            return
        }

        saveData = {
            solicitud: data.idSolicitud,
            tpSolicitud: 'Asignar Trsnsportador',
            claseSolicitud: null,
            comentario: '',
            activo: null,
            estado: data.idEstado
        }
        saveData = {
            ...saveData,
            jsItems: {
                arrTransportador: jsTransportador
            }
        }

        try {

            saveData.jsItems = JSON.stringify(saveData.jsItems)

            let res = await evaluacionSolicitudServices.setTransporte(saveData)

            saveData = {
                solicitud: data.idSolicitud,
                tpSolicitud: 'Asignar Vehiculo',
                claseSolicitud: null,
                comentario: '',
                activo: null,
                estado: data.idEstado
            }

            saveData = {
                ...saveData,
                jsItems: {
                    arrVehiculo: jsVehiculo
                }
            }

            saveData.jsItems = JSON.stringify(saveData.jsItems)

            let resVehiculo = await evaluacionSolicitudServices.setTransporte(saveData)

            if (resVehiculo.data.idmsg === 200) {
                toggleOverlay()
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: resVehiculo.data?.txmsg } });
                dispatch({
                    type: 'setStateGeneralServices', generalServices: {
                        ...generalServicesState,
                        updateTransportador: true
                    }
                })
            }

        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: 'Ha ocurrido un error' } });
            console.log(error)
        }
    }

    const onGridReady = params => {

        params.api.forEachNodeAfterFilter(nodo => {
            nodo.setSelected(nodo.data.documento === transporteSelected?.document)
        })
    }

    const onGridReadyVehiculo = params => {

        params.api.forEachNodeAfterFilter(nodo => {
            nodo.setSelected(nodo.data.nbPlaca === transporteSelected?.placa)
        })
    }

    return (
        <div>
            <FormProvider {...methods} className="w-100">
                <Modal
                    id={`modalId`}
                    size={'xl'}
                    show={open}
                    onHide={toggleOverlay}
                    backdrop="static"
                    className="modalCRUD p-0 m-0"
                    centered
                >
                    <Modal.Header className="headerModal" closeButton>
                        <a className="icon-container">
                            <div />
                            <i className="fas fa-pen" />
                        </a>
                        <Modal.Title className="mb-0">
                            Evaluación Solicitud
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4">

                        <div className={`d-flex align-items-center justify-content-end mt-1`}>

                            {/* <ExternalActionsTable
                                accionVisibilidadColumnas={tableVehiculo}
                            /> */}
                            <Tooltip title="Visto Bueno" aria-label="guardar-producto">
                                <a className="icon-container-actions d-flex "
                                    onClick={() => aceptar()}>
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="far fa-save fa-2x" />
                                </a>
                            </Tooltip>
                        </div>

                        <div className='d-flex align-items-center justify-content-between'>

                            <div style={{ width: '49%' }}>
                                <h5>Selecciona un Vehiculo</h5>
                                <AgGridTable
                                    referencia={tableVehiculo}
                                    columnDef={columnDefVehiculos}
                                    dataList={dataVehiculos || []}
                                    onGridReady={onGridReadyVehiculo}
                                    rowSelection="single"
                                    height="35vh"
                                />
                            </div>
                            <div style={{ width: '49%' }}>
                                <h5>Selecciona un Transportador</h5>
                                <AgGridTable
                                    referencia={tableTransportador}
                                    columnDef={columnDefTransportadores}
                                    dataList={dataConductores || []}
                                    onGridReady={onGridReady}
                                    rowSelection="single"
                                    height="35vh"
                                    style={{ marginLeft: '10px' }}
                                />
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </FormProvider>
        </div>
    );
}

const AsignarTransporte = ({ data }) => {

    const tableVehiculo = useRef(null)
    const tableTransportador = useRef(null)
    const [dataVehiculos, setDataVehiculos] = useState([])
    const [dataRutas, setDataRutas] = useState([])
    const [dataConductores, setDataConductores] = useState([])
    const [dataTable, setDataTable] = useState({})
    const [showModal, setShowModal] = useState(false)

    const dispatch = useDispatch()

    const generalServicesState = useSelector(state => state.generalServices)

    useEffect(async () => {

        dispatch({
            type: 'setStateGeneralServices', generalServices: {
                ...generalServicesState,
                updateTransportador: false
            }
        })

        let res = await evaluacionSolicitudServices.getTransportadores({ codigo: data.iderp, agente: data.nbAgenteComercial })
        let resAsignado = await evaluacionSolicitudServices.getTransporteAsignado(data.idSolicitud)
        setDataVehiculos(res.data.transportadores)
        setDataConductores(res.data.conductores)
        setDataTable(resAsignado.data[0])

        let jsRutas = res.data.rutas.map((item, i) => {

            let dias = JSON.parse(item?.jsRuta)?.arrRutas.map(el => el.DiaV)
            return {
                ...item,
                jsRuta: dias
            }
        })

        setDataRutas(jsRutas)

    }, [generalServicesState?.updateTransportador])

    return (
        <div className='mt-3 '>

            <table style={{ width: '30%', marginTop: '10px' }} >
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                        <td>Dias de Visita</td>
                        <td>Zona</td>
                    </tr>
                </thead>

                <tbody>

                    {dataRutas.lenght === 0 && <tr></tr>}
                    {
                        dataRutas.map((el, i) => (

                            <tr key={i + 1} style={{ fontWeight: 'bold' }}>
                                <td>{el.jsRuta.join()}</td>
                                <td>{el.CodVendedor}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>

            <div className={`d-flex align-items-center justify-content-end mt-1`}>

                {
                    (data.idEstado == 52 || data.idEstado == 53) && <Tooltip title="Asignar" aria-label="Asignar">
                        <a className="icon-container-actions d-flex "
                            onClick={() => setShowModal(!showModal)}>
                            <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                            <i style={{ color: Colors.COLOR_GREEN_DARK }} className="far fa-pen fa-2x" />
                        </a>
                    </Tooltip>
                }
            </div>

            <div className='d-flex align-items-center justify-content-between'>

                <table style={{ width: '100%', marginTop: '10px' }} >
                    <thead>
                        <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                            <td>Responsable</td>
                            <td>Clase Vehiculo</td>
                            <td>Placa</td>
                            <td>Transportador</td>
                            <td>Documento</td>
                            <td>Celular</td>
                        </tr>
                    </thead>

                    <tbody>

                        <tr style={{ fontWeight: 'bold' }}>
                            <td>{dataTable?.responsable}</td>
                            <td>{dataTable?.clase}</td>
                            <td>{dataTable?.placa}</td>
                            <td>{dataTable?.nombre}</td>
                            <td>{dataTable?.documento}</td>
                            <td>{dataTable?.celular}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <FormDialogAsignarTransporte open={showModal} toggleOverlay={() => setShowModal(!showModal)} data={data} dataVehiculos={dataVehiculos} tableVehiculo={tableVehiculo} dataConductores={dataConductores} tableTransportador={tableTransportador} transporteSelected={{ placa: dataTable?.placa, document: dataTable?.documento }} />
        </div>
    )
}

const HistoricoSolicitudes = ({ solicitud }) => {
    const [dataSolicitudes, setDataSolicitudes] = useState([])

    useEffect(async () => {

        let res = await evaluacionSolicitudServices.getHistoricoSolicitud(solicitud)

        setDataSolicitudes(res.data)

    }, [solicitud])

    return (
        <div>

            <table style={{ width: '100%', marginTop: '10px' }} >
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>

                        <td>Id Item</td>
                        <td>Tipo Solicitud</td>
                        <td>Identificador</td>
                        <td>Causal / Descripción</td>
                        <td>Comentario / Nombre</td>
                        <td>Id Estado</td>
                        <td>Estado</td>
                        <td>Usr Auditor</td>
                        <td>Fecha Auditoria</td>
                    </tr>
                </thead>

                <tbody>
                    {/* { el?.txRecurso?.lenght === 0 && <tr></tr> } */}
                    {
                        dataSolicitudes.map((el, i) => (

                            <tr key={el?.idItem} >
                                <td>{el?.idItem}</td>
                                <td>{el?.tpSolicitud}</td>
                                <td>{el?.nbRecurso}</td>
                                <td>{el?.nmRecurso}</td>
                                <td>{el?.txRecurso}</td>
                                <td>{el?.idEstado}</td>
                                <td style={{ fontWeight: 'bold' }}>{el?.nmEstado}</td>
                                <td>{el?.idUsrAuditoria}</td>
                                <td>{el?.dtUsrAuditoria}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

const Historico = ({ table }) => {
    return (
        <div>
            <AgGridTable
                referencia={table}
                // columnDef={columnDefChildren}
                dataList={[]}
                // onGridReady={onGridReady}
                rowSelection="multiple"
                height="25vh"
            />
        </div>
    )
}

const Ventas = ({ data }) => {

    const [dataVentas, setDataVentas] = useState([])

    useEffect(async () => {

        let res = await evaluacionSolicitudServices.getHistoricoVentas({ agente: data.nbAgenteComercial, cliente: data.iderp })

        setDataVentas(res.data)
    }, [data])


    return (
        <div>
            <table style={{ width: '100%', marginTop: '10px' }} >
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                        <td>Agente Comercial</td>
                        <td>Punto Venta</td>
                        <td>Año</td>
                        <td>Mes</td>
                        <td>Vl. Venta</td>
                    </tr>
                </thead>

                <tbody>
                    {dataVentas.lenght === 0 && <tr></tr>}
                    {
                        dataVentas.map((el, i) => (

                            <tr key={i + 1} style={{ fontWeight: 'bold' }}>
                                <td>{el.nbAgenteComercial}</td>
                                <td>{el.idPuntoVenta}</td>
                                <td>{el.anno}</td>
                                <td>{el.mes}</td>
                                <td>{el.vlVentaSinIVA}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

const Evidencias = ({ data }) => {

    const [dataEvidencias, setDataEvidencias] = useState([])

    useEffect(() => {

        if (data?.txRecurso != undefined) {

            let jsRecurso = JSON.parse(data?.txRecurso)

            let comments = jsRecurso.map(async el => {
                let resImg = await evaluacionSolicitudServices.getComentarioByImg(el.nmRecurso)
                return { ...el, comentario: resImg.data.descripcion, nmRecurso: resImg.data.ruta }
            })
            Promise.all(comments).then(value => setDataEvidencias([...value]))
        }

    }, [data])

    return (
        <div>
            <table style={{ width: '100%', marginTop: '10px' }} className="">
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                        <td>Item</td>
                        <td>Comentario</td>
                        <td>Enlace</td>
                    </tr>
                </thead>

                <tbody>
                    {dataEvidencias.lenght === 0 && <tr></tr>}
                    {
                        dataEvidencias.map((el, i) => (

                            <tr key={el.id} style={{ fontWeight: 'bold' }}>
                                <td>{el.id}</td>
                                <td>{el?.comentario}</td>
                                <td>
                                    <Zoom overlayBgColorEnd='rgba(0, 0, 0, 0.85)' >
                                        <img className="" src={`${el.nmRecurso}`}
                                            style={{ width: 100, height: 100, borderRadius: 10, objectFit: 'contain' }} />
                                    </Zoom>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

const Referencias = ({ data }) => {

    const [dataReferencias, setDataReferencias] = useState([])

    useEffect(() => {

        if (data?.txRecurso != undefined) {
            setDataReferencias(JSON.parse(data?.txRecurso))
        }

    }, [data])

    return (
        <div>
            <table style={{ width: '100%', marginTop: '10px' }} >
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                        <td>Item</td>
                        <td>Nombre</td>
                        <td>Documento</td>
                        <td>Teléfono</td>
                    </tr>
                </thead>

                <tbody>
                    {dataReferencias.lenght === 0 && <tr></tr>}
                    {
                        dataReferencias.map((el, i) => (

                            <tr key={el.id} style={{ fontWeight: 'bold' }} >
                                <td>{el.id}</td>
                                <td>{el.nmRecurso}</td>
                                <td>{el.nbRecurso}</td>
                                <td>{el.nbTelefono}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

const Solicitudes = ({ dataS, data, activo }) => {

    const [show, setShow] = useState(false)
    const [showActivo, setShowActivo] = useState(false)
    const [showDatosActivo, setShowDatosActivo] = useState(false)
    const [showDatosRetiro, setShowDatosRetiro] = useState(false)
    const [visible, setVisible] = useState(false);
    const [dataActivo, setDataActivo] = useState({});
    const [dataTraslado, setDataTraslado] = useState({});
    const tableDisponibles = useRef(null);

    const dispatch = useDispatch()
    const generalServicesState = useSelector(state => state.generalServices)

    useEffect(async () => {

        dispatch({
            type: 'setStateGeneralServices', generalServices: {
                ...generalServicesState,
                updateActivoAsignado: false
            }
        })


        setShow(false)
        if ((data?.tpGrupSolicitud == 'Petición de Activo' || data?.tpGrupSolicitud == 'Petición Cambio' || data?.tpGrupSolicitud == 'Reporte Activo No Registrado') && data?.idEstado != 51) {
            setShow(true)
        }

        setShowActivo(false)
        if (data?.tpGrupSolicitud == 'Petición de Activo' || data?.tpGrupSolicitud == 'Petición Retiro' || data?.tpGrupSolicitud == 'Petición Cambio' || data?.tpGrupSolicitud == 'Reporte Activo No Registrado') {
            setShowActivo(true)
        }

        setShowDatosActivo(true)
        if (data?.tpGrupSolicitud == 'Petición Mantenimiento' || data?.tpGrupSolicitud == 'Petición Retiro') {
            setShowDatosActivo(false)
        }

        setShowDatosRetiro(true)
        data?.tpGrupSolicitud == 'Petición Retiro' ? setShowDatosRetiro(true) : setShowDatosRetiro(false)

        try {

            let res = await evaluacionSolicitudServices.getActivoAsignado(data.idSolicitud)
            let response = await evaluacionSolicitudServices.getDataSolicitudTraslado(data.nbActivo,data.dtSolicitud)

            if (res.status) {
                setDataActivo(res.data)
            }
            if (response.status) {
                setDataTraslado(response.data || {})
            }

        } catch (error) {
            console.log(error)
        }

    }, [data?.tpGrupSolicitud, generalServicesState?.updateActivoAsignado])

    return (
        <div>
            <table style={{ width: '100%' }} className="">
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                        <td>Id Causal</td>
                        <td>Causal</td>
                        <td>Fecha Propuesta de atención</td>
                        <td>Comentario</td>
                    </tr>
                </thead>

                <tbody>
                    <tr style={{ fontWeight: 'bold' }} >
                        <td>{dataS?.nbRecurso}</td>
                        <td>{dataS?.nmRecurso}</td>
                        <td>{data?.dtPropuestaAtencion}</td>
                        <td>{dataS?.txRecurso}</td>
                    </tr>
                </tbody>
            </table>

            <h6 style={{ marginTop: '10px', fontWeight: 'bold' }} className={`${showActivo ? 'd-flex' : 'd-none'}`} >Datos de Activo ({data?.tpGrupSolicitud})</h6>
            <table style={{ width: '100%', marginTop: '10px' }} className={`${showActivo ? 'd-table' : 'd-none'}`} >
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                        <td>Id Referencia</td>
                        <td>Referencia</td>
                        <td>Cantidad</td>
                        <td>Placa Registrada</td>
                        <td>Placa Solicitud</td>
                        <td className={`${show ? 'd-flex' : 'd-none'}`} >Asignar</td>
                    </tr>
                </thead>

                <tbody>
                    <tr style={{ fontWeight: 'bold' }} >
                        <td>{activo?.nbRecurso}</td>
                        <td>{activo?.nmRecurso}</td>
                        <td>{activo?.nbCantidad}</td>
                        <td>{data?.tpGrupSolicitud == 'Petición de Activo' || data?.tpGrupSolicitud == 'Petición Cambio' ? '' : data?.nbActivo}</td>
                        <td>{data?.Activo}</td>
                        <td className={`${!show || data?.idEstado == 55 || data?.idEstado == 56 || data?.idEstado == 57 || data?.idEstado == 58 ? 'd-none' : 'd-flex'}`} >
                            <div className={`d-flex align-items-center`}>

                                <Tooltip title="Asignar o editar activo" aria-label="Asignar" style={{ marginLeft: '20px' }}>
                                    <a className="icon-container-actions d-flex "
                                        onClick={() => setVisible(true)}>
                                        <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                        <i style={{ color: Colors.COLOR_GREEN_DARK }} className="far fa-pen fa-2x" />
                                    </a>
                                </Tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* <h6 style={{marginTop: '10px', fontWeight: 'bold'}} className={`${showActivo ? 'd-flex' : 'd-none'}`} >Datos de Activo Asignado</h6> */}
            <table style={{ width: '100%', marginTop: '10px' }} className={`${showDatosActivo ? 'd-table' : 'd-none'}`}>
                <thead>
                    <tr style={{ fontWeight: 'bold', color: '#37A6DE' }}>
                        <td colSpan={5}>DATOS DE ACTIVO ASIGNADO</td>
                        <td colSpan={3}>ESTADOS</td>
                    </tr>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040', }}>
                        <td>Referencia</td>
                        <td>Placa</td>
                        <td>Nombre</td>
                        <td>Propietario</td>
                        <td>De Ubicación</td>
                        <td>De Disponibilidad</td>
                        <td>Del Activo</td>
                    </tr>
                </thead>

                <tbody>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td>{dataActivo.referencia}</td>
                        <td>{dataActivo.activo}</td>
                        <td>{dataActivo.txRecurso}</td>
                        <td>{dataActivo.idPropietario} - {dataActivo.nmPropietario}</td>
                        <td>{dataActivo.nmUbicacion}</td>
                        <td>{dataActivo.nameAvailable}</td>
                        <td>{dataActivo.nmEstado}</td>
                    </tr>
                </tbody>
            </table>

            <h6 style={{marginTop: '10px', fontWeight: 'bold', color: '#37A6DE'}} className={`${showDatosRetiro ? Object.keys(dataTraslado).length > 0 ? 'd-table' : 'd-none' : 'd-none'}`} >TRASLADO ASOCIADO (Datos de Solicitud)</h6>
            <table style={{ width: '100%' }} className={`${showDatosRetiro ? Object.keys(dataTraslado).length > 0 ? 'd-table' : 'd-none' : 'd-none'}`}>
                <thead>
                    <tr style={{ backgroundColor: '#ebebeb', color: '#404040' }}>
                        <td>Id Solicitud</td>
                        <td>Documento</td>
                        <td>Nombre</td>
                    </tr>
                </thead>

                <tbody>
                    <tr style={{ fontWeight: 'bold' }} >
                        <td>{dataTraslado?.idSolicitud}</td>
                        <td>{dataTraslado?.nbRecurso}</td>
                        <td>{dataTraslado?.nmRecurso}</td>
                    </tr>
                </tbody>
            </table>

            <AsignarActivo open={visible} toggleOverlay={() => setVisible(!visible)} data={data} table={tableDisponibles} activo={dataActivo.activo} activoS={activo}/>
        </div>
    )
}

const FormCRUD = ({ properties }) => {

    const { data } = properties

    const generalServicesState = useSelector(state => state.generalServices)

    const [visible, setVisible] = useState(false);
    const [showGestion, setShowGestion] = useState(true);
    const [dataActivo, setDataActivo] = useState({})
    const [dataActivoS, setDataActivoS] = useState({})
    const [dataSolicitud, setDataSolicitud] = useState({})
    const [dataReferencias, setDataReferencias] = useState({})
    const [dataEvidencias, setDataEvidencias] = useState({})
    const [dataClienteTraslado, setDataClienteTraslado] = useState({})
    const methods = useForm({
        defaultValues: {
            ...data
        }
    });
    // const { register, handleSubmit, formState: { errors }, control } = methods;

    useEffect(async () => {

        let jsItems = JSON.parse(data.jsItemSolicitudes)

        let tempSolicitud = jsItems.arrItems.find(el => el.tpSolicitud == 'Solicitud')
        let temp = jsItems.arrItems.find(el => el.tpSolicitud == 'Ref. Activo')
        let tempRef = jsItems.arrItems.find(el => el.tpSolicitud == 'Ref. Personales')
        let tempEvi = jsItems.arrItems.find(el => el.tpSolicitud == 'Inf. Evidencias')

        setDataActivoS({ ...temp })
        setDataSolicitud({ ...tempSolicitud })
        setDataReferencias({ ...tempRef })
        setDataEvidencias({ ...tempEvi })

        setShowGestion(false)
        if (data.tpGrupSolicitud.includes('Traslado')) {

            let {data: state} = await evaluacionSolicitudServices.validarEstadoSolicitudRetiro(data?.nbActivo || '',data?.dtSolicitud.slice(0,10))
            let {data: res} = await evaluacionSolicitudServices.getDataSolicitudTraslado(data?.nbActivo || '',data?.dtSolicitud)

            setDataClienteTraslado(res)

            if (state == 'pendiente') {
                setShowGestion(true)
            }
        }

        if (data.tpGrupSolicitud.includes('Mantenimiento') || data.tpGrupSolicitud.includes('Cambio') || data.tpGrupSolicitud.includes('Retiro')) {

            let res = await evaluacionSolicitudServices.getActivoById(data?.nbActivo || '')
    
            setDataActivo({ ...res.data })
        }

    }, [data?.idSolicitud])

    return (
        <>
            <div className='container mx-0 px-0 w-100 mw-100'>

                <div className="d-flex justify-content-between align-items-center">
                    <h6>{`Solicitud de Activo No: ${data.idSolicitud} - ${data.tpGrupSolicitud}`}</h6>

                    <div className='d-flex align-items-center'>
                        <div className={`${showGestion ? 'd-none' : 'd-flex align-items-center'}`}>
                            <span>Estado:</span> <span style={{ fontWeight: 'bold', marginLeft: '10px', color: '#37A6DE' }}>{data.nmEstado}</span>
                        </div>
                        <div className={`${!showGestion ? 'd-none' : 'd-flex'}`}>
                            <span>Solicitud de retiro pendiente por gestionar</span>
                        </div>

                        <div className={`${showGestion || data?.idEstado == 53 || data?.idEstado == 55 || data?.idEstado == 56 || data?.idEstado == 57 || data?.idEstado == 58 ? 'd-none' : 'd-flex'} `}>
                            <Tooltip title="Visto Bueno" aria-label="guardar-producto" style={{ marginLeft: '20px' }}>
                                <a className="icon-container-actions d-flex "
                                    onClick={() => setVisible(true)}>
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="far fa-pen fa-2x" />
                                </a>
                            </Tooltip>
                        </div>
                    </div>

                </div>

                <div>
                    <table style={{ width: '100%', marginTop: '3px' }} className="">
                        <thead>
                            <tr style={{ fontWeight: 'bold', color: '#37A6DE' }}>
                                <td colSpan={4}>SOLICITANTE</td>
                                <td colSpan={3}>CLIENTE</td>
                            </tr>
                            <tr style={{ backgroundColor: '#ebebeb', color: '#404040', }}>
                                <td>Zona</td>
                                <td>Nombre</td>
                                <td>Documento</td>
                                <td>Tipo</td>
                                <td>Nombre</td>
                                <td>Cod. Erp</td>
                                <td>Agente</td>
                            </tr>

                        </thead>
                        <tbody>
                            <tr style={{ fontWeight: 'bold' }}>
                                <td>{data.nbZona}</td>
                                <td>{data.nmSolicitante}</td>
                                <td>{data.nbSolicitante}</td>
                                <td>{data.tpSolicitante}</td>
                                <td>{data?.tpGrupSolicitud == 'Traslado de Cliente' ? data.nmTraslado : data.nmRazon}</td>
                                <td>{data?.tpGrupSolicitud == 'Traslado de Cliente' ? data.nbTraslado : data.iderp}</td>
                                <td>{data.nbAgenteComercial} - {data.nmAgenteComercial}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style={{ width: '100%', marginTop: '10px' }} className="">
                        <thead>

                            <tr>
                                <td style={{ fontWeight: 'bold', color: '#37A6DE' }} colSpan={7}>PUNTO DE VENTA</td>
                            </tr>
                            <tr style={{ backgroundColor: '#ebebeb', color: '#404040', }}>
                                <td>Nombre Comercial</td>
                                <td>Dirección</td>
                                <td>Barrio</td>
                                <td>Ciudad</td>
                                <td>Teléfono 1</td>
                                <td>Teléfono 2</td>
                                <td>Tipología</td>
                            </tr>
                        </thead>
                        <tbody>

                            <tr style={{ fontWeight: 'bold' }}>
                                <td>{Object.keys(dataClienteTraslado).length > 0 ? dataClienteTraslado?.nmRecurso : data.nmNegocio}</td>
                                <td>{Object.keys(dataClienteTraslado).length > 0 ? dataClienteTraslado?.txDireccion : data.txDireccion}</td>
                                <td>{Object.keys(dataClienteTraslado).length > 0 ? dataClienteTraslado?.txBarrio : data.txBarrio}</td>
                                <td>{Object.keys(dataClienteTraslado).length > 0 ? dataClienteTraslado?.nmCiudad : data.nmCiudad}</td>
                                <td>{Object.keys(dataClienteTraslado).length > 0 ? dataClienteTraslado?.nbTelMovil : data.nbTelFijo}</td>
                                <td>{Object.keys(dataClienteTraslado).length > 0 ? dataClienteTraslado?.nbTelFijo : data.nbTelMovil}</td>
                                <td>{Object.keys(dataClienteTraslado).length > 0 ? dataClienteTraslado?.idTipologia : data.idTipologia}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style={{ width: '100%', marginTop: '10px' }} className="">
                        <thead>
                            <tr style={{ fontWeight: 'bold', color: '#37A6DE' }}>
                                <td colSpan={5}>DATOS DE ACTIVO ASIGNADO</td>
                                <td colSpan={3}>ESTADOS</td>
                            </tr>
                            <tr style={{ backgroundColor: '#ebebeb', color: '#404040', }}>
                                <td>Tipo Referencia</td>
                                <td>Referencia</td>
                                <td>Placa</td>
                                <td>Propietario</td>
                                <td>De Ubicación</td>
                                <td>De Disponibilidad</td>
                                <td>Del Activo</td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr style={{ fontWeight: 'bold' }}>
                                <td>{dataActivo.tpReferencia}</td>
                                <td>{dataActivo.referencia}</td>
                                <td>{dataActivo.activo}</td>
                                <td>{dataActivo.idPropietario} - {dataActivo.nmPropietario}</td>
                                <td>{dataActivo.nmUbicacion}</td>
                                <td>{dataActivo.nameAvailable}</td>
                                <td>{dataActivo.nmEstado}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='mt-3 d-flex align-items-center px-3 py-4 bg-white boxShadow borderRadius5'>
                    <TabsClassic
                        tabs={[
                            {
                                id: 1,
                                label: "Datos Solicitudes",
                                content: <Solicitudes dataS={dataSolicitud} data={data} activo={dataActivoS} />
                            },
                            {
                                id: 2,
                                label: "Evidencias",
                                content: <Evidencias data={dataEvidencias} />
                            },
                            {
                                id: 3,
                                label: "Referencias",
                                content: <Referencias data={dataReferencias} />
                            },
                            {
                                id: 4,
                                label: "Ventas",
                                content: <Ventas data={data} />
                            },
                            // {
                            //     id: 5,
                            //     label: "Historico Activo",
                            //     content: <Evidencias table={tableEvidencias} />
                            // },
                            {
                                id: 6,
                                label: "Asignación Transporte",
                                content: <AsignarTransporte data={data} />
                            },
                            // {
                            //     id: 7,
                            //     label: "Documentos",
                            //     content: <Evidencias table={tableEvidencias} />
                            // },
                            {
                                id: 8,
                                label: "Historico Solicitud",
                                content: <HistoricoSolicitudes solicitud={data.idSolicitud} />
                            },
                        ]} />
                </div>
            </div>
            <FormDialog open={visible} toggleOverlay={() => setVisible(!visible)} data={data} causales={generalServicesState} />

        </>
    )
}

export default FormCRUD

